/*
 * Imports
 */
// lib
// Classes
import MegaMenue from './components/mega-menue';
import Tabs from './lib/tabs';
// objects
import SearchTrigger from './components/search-trigger';
// functions
import bodySpacing from './components/body-spacing';
import menuIconHandler from './components/menu-icon-handler';
import mobileMenuTrigger from './components/mobile-menue-trigger';
import ceAccordion from './elements/ce-accordion';


/*
 * execution
 */
// components
bodySpacing();
menuIconHandler();
mobileMenuTrigger();
SearchTrigger;

// elements
ceAccordion();

// mega menu
new MegaMenue('.megamenu');

// tabs
const tabs = document.querySelectorAll('[id^=tabs_]');

if(tabs != null) {
  tabs.forEach((tab) => {
    let openIndex = 0;

    if(tab.getAttribute('tab-index')) {
      openIndex = tab.getAttribute('tab-index');
    }

    new Tabs ({
      elem: tab.id,
      open: parseInt(openIndex)
    });
  });
}
